import { gql } from "@grandvisionhq/graphql";
const failureFragment = gql`
  fragment ShoppinglistFailureFragment on ShoppinglistByIdFailure {
    ... on ShoppinglistNotFoundFailure {
      message
    }
    ... on ShoppinglistAuthorizationFailure {
      message
    }
    ... on ShoppinglistValidationFailure {
      message
    }
    ... on ShoppinglistFailure {
      message
    }
  }
`;
export {
  failureFragment
};
//# sourceMappingURL=failure-fragment.js.map
